define('Inspiredspaces.ei1.Main', [
    'Inspiredspaces.ei1.Main.View'
], function (InspiredspacesMainView) {
    'use strict';

    return {
        mountToApp: function (container) {
            const Layout = container.getComponent('Layout');
            if (Layout) {
                console.log('Layout component found, adding child view');
                Layout.addChildView('Inspiredspaces.ei1.Main', function () {
                    console.log('Child view factory called');
                    return new InspiredspacesMainView({ container: container, });
                });
            }
        }
    };
});
